import { Component, Output, EventEmitter } from '@angular/core';
import { DocumentItemComponent } from 'app/shared/components/document-item/document-item.component';
import { Router, ActivatedRoute } from '@angular/router';
import { CompetitionService } from 'app/services/competition.service';

@Component({
  selector: 'app-camera-attached-document-item',
  templateUrl: './camera-attached-document-item.component.html',
  styleUrls: ['./camera-attached-document-item.component.scss']
})
export class CameraAttachedDocumentItemComponent extends DocumentItemComponent {
  @Output() delete = new EventEmitter();

  constructor(router: Router,
    activatedRoute: ActivatedRoute,
    competitionService: CompetitionService) {
    super(router, activatedRoute, competitionService);
  }

  override onDelete() {
    this.delete.emit(this.file);
  }
}
